
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"9","height":"21.5","viewBox":"0 0 9 21.9"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"a",attrs:{"d":"M7.2 13.7v-11a2.7 2.7 0 10-5.4 0v11.1A4.547 4.547 0 000 17.4a4.5 4.5 0 009 0 4.743 4.743 0 00-1.8-3.7zm-2.7 6.9a3.329 3.329 0 01-3.3-3.3A3.116 3.116 0 013 14.4V2.7a1.5 1.5 0 013 0v11.7a3.223 3.223 0 011.8 2.9 3.329 3.329 0 01-3.3 3.3z"}}),_c('path',{staticClass:"a",attrs:{"d":"M5.3 15V7.8H3.6V15A2.41 2.41 0 002 17.3a2.5 2.5 0 005 0A2.565 2.565 0 005.3 15z"}})])
          )
        }
      }
    